import { Controller } from "@hotwired/stimulus"

// Verify email screen (users/show_verification_prompt). The page subscribes to
// a turbo stream; when the link in the email is clicked in another tab, the
// server appends an element carrying this controller and the tab moves on to
// the app, where the sign-up guards land it on Setup. No verified state is
// shown in between.
export default class extends Controller {
  static values = { url: String }

  connect() {
    if (this.urlValue) window.location.replace(this.urlValue)
  }
}
